// import Permission from "../../../../common/components/auth/Permission";
// import SubTablePurchaseOrder from "../tables/SubTablePurchaseOrder";
import { usePurchaseOrderDashboardContext } from "./PurchaseOrder.context";

import './index.scss'
import InfoTablePurchaseOrder from "../tables/InfoTablePurchaseOrder";
import { IPurchaseOrder } from "@/types/purchaseOrder.types";
import Loading from "@/common/components/ui/loading/Loading";

export function PurchaseOrderDashboard() {
  const { purchaseOrder, isLoading } = usePurchaseOrderDashboardContext();

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div className="box-border flex h-full min-h-0 w-full flex-col overflow-hidden bg-white py-2 text-black">
      <div className="min-h-0 flex-1 overflow-y-auto overflow-x-hidden [scrollbar-gutter:stable]">
        <InfoTablePurchaseOrder purchaseOrder={purchaseOrder as IPurchaseOrder} />
      </div>
    </div>
  );
}
